export const CUSTOMER_PROFILE_MIN_AGE = 18;
export const CUSTOMER_PROFILE_MAX_AGE = 120;
